module.exports = __webpack_public_path__ + "static/media/stofferingen-23.9c6c2c9f.jpg";